<div class="molecular-formula-form-container">
  <div class="molecular-formula-form-item-container">
    <div class="molecular-formula-form-item-input-container">
      <mat-form-field appearance="outline" class="molecular-formula-form-form-field">
        <mat-label>{{ formFieldTitle }}</mat-label>
        <input matInput #molecularFormulaInput name="molecularFormula" [(ngModel)]="molecularFormula" class="molecular-formula-form molecular-formula-form-item-input"
          (keyup.enter)="updateMolecularFormula($event)" (blur)="updateMolecularFormula($event)" />
        <mat-icon matSuffix class="molecular-formula-form-trailing-icon" (mousedown)="clearMolecularFormulaInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="error" *ngIf="hasFieldValidationError(formFieldName, 'required')">
      This is a required field. You may also upload a file containing the molecular formula below.
    </div>
    <div class="error" *ngIf="!hasFieldValidationError(formFieldName, 'required') && hasFieldValidationError(formFieldName, 'pattern')">
      The formula entered does not conform to standard notation.
    </div>
  </div>
  <div class="molecular-formula-form-info molecular-formula-form-info-text">
    {{ infoText }}
  </div>
  <div>
    <app-molecular-formula-dialog [substanceType]="substanceType"></app-molecular-formula-dialog>
  </div>
</div>